import View from 'view/view'
import React from 'react'
import ReactDOM from 'react-dom'
import FullViewportImage from 'app/components/presentational/FullViewportImage'

export default View.extend({
    imageContainer: null,
    imageUrl: null,

    events: {
        'click .js-full-viewport-image-link': '_onImageLinkClick',
    },

    _onImageLinkClick(e) {
        e.preventDefault()

        ReactDOM.render(<FullViewportImage imageSrc={this.imageUrl} />, this.imageContainer[0])
    },

    initialize() {
        this.imageContainer = this.$('.js-full-viewport-image-container')
        this.imageUrl = this.$('.js-full-viewport-image-link').attr('href')
    },
})
